<template>
  <div class="h-100 d-flex">
    <div class="overflow-auto w-100">
      <div class="d-flex flex-column min-h-100 w-100 p-1">
        <div class="d-flex justify-content-between align-items-center mb-2">
          <div class="d-flex align-items-center">
            <b-button variant="outline-secondary" class="size-button-center mr-1" @click="$emit('slide_window')">
              <span><feather-icon icon="MenuIcon"/></span>
            </b-button>
            <b-button
              v-if="view !== 'history'"
              variant="flat-secondary"
              class="btn-icon mr-50"
              :title="$t('ia.contents.backToHistory')"
              @click="goToHistory"
            >
              <feather-icon icon="ArrowLeftIcon" size="18"></feather-icon>
            </b-button>
            <h4 class="mb-0">{{ view === 'new' ? $t('ia.contents.newRequest') : $t('ia.contents.title') }}</h4>
            <b-badge variant="primary" class="custom-badge-sections-ia">{{ $t('newFeature') }}</b-badge>
          </div>
          <b-button v-if="view !== 'new'" class="generate-contents-ai" @click="goToForm">
            <feather-icon icon="PlusIcon" class="mr-25"></feather-icon>{{ $t('ia.contents.newRequest') }}
          </b-button>
        </div>

        <contents-history
          v-if="view === 'history'"
          :source="source"
          @new_request="goToForm"
          @open_request="goToRequest"
        ></contents-history>
        <contents-results
          v-else-if="view === 'request'"
          :uuid="$route.params.uuid"
          :initial_request="created_request"
          :source="source"
          @new_request="goToForm"
          @finished="$emit('refresh_credits')"
        ></contents-results>
        <contents-form
          v-else
          class="flex-grow-1"
          :source="source"
          :credits="credits"
          @created="onCreated"
        ></contents-form>
      </div>
    </div>
  </div>
</template>

<script>
import { BButton, BBadge } from "bootstrap-vue";

export default {
  name: 'ContentsContainer',
  components: {
    BButton,
    BBadge,
    ContentsHistory: () => import('./ContentsHistory.vue'),
    ContentsForm: () => import('./ContentsForm.vue'),
    ContentsResults: () => import('./ContentsResults.vue'),
  },
  props: {
    // { type: 'campaign' | 'casting_call', uuid } or null for standalone BrandMeAI
    source: {
      type: Object,
      default: null,
    },
    credits: {
      type: Number,
      default: null,
    },
  },
  data() {
    return {
      created_request: null,
    };
  },
  computed: {
    // history (default) | new | request
    view() {
      const { category, uuid } = this.$route.params;
      if (category === 'new') return 'new';
      if (category === 'request' && uuid) return 'request';
      return 'history';
    },
  },
  methods: {
    onCreated(request) {
      this.created_request = request;
      this.$emit('refresh_credits');
      this.goToRequest(request.uuid);
    },
    goToRequest(uuid) {
      this.$router.push({ name: 'brandme_AI', params: { section: 'contents', category: 'request', uuid } }).catch(() => {});
    },
    goToForm() {
      this.created_request = null;
      this.$router.push({ name: 'brandme_AI', params: { section: 'contents', category: 'new' } }).catch(() => {});
    },
    goToHistory() {
      this.created_request = null;
      this.$router.push({ name: 'brandme_AI', params: { section: 'contents', category: 'history' } }).catch(() => {});
    },
  },
};
</script>

<style lang="scss" scoped>
.min-h-100 {
  min-height: 100%;
}
.size-button-center {
  padding: 0.6rem;
}
.generate-contents-ai {
  border: 0;
  background: linear-gradient(to left bottom, rgb(124, 214, 175), rgb(62, 123, 160));
}
</style>
